import React from 'react'
import { List, WhiteSpace } from 'antd-mobile'
import { IRedItem } from './index.d'

const RedDetailItem: React.FC<IRedItem> = (props) => {
  const { title, description, log_time, amount } = props
  return (
    <List.Item
      extra={
        <div>
          <b className="color-orange text-md">
            {Number(amount) >= 0 ? '+' : ''}
            {amount}元
          </b>
          <WhiteSpace size="sm" />
          <div className="text-sm">{log_time}</div>
        </div>
      }
      multipleLine
    >
      <b className="text-md">{title}</b>
      {description && (
        <List.Item.Brief>
          <div className="text-sm">{description}</div>
        </List.Item.Brief>
      )}
    </List.Item>
  )
}

export default RedDetailItem
